/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { cueStatsCommonActionsResponse } from '../models/cueStatsCommonActionsResponse';
import type { cueStatsContactSalesResponse } from '../models/cueStatsContactSalesResponse';
import type { cueStatsCreditAuditLogResponse } from '../models/cueStatsCreditAuditLogResponse';
import type { cueStatsRoiResponse } from '../models/cueStatsRoiResponse';
import type { cueStatsTeamLeaderboardResponse } from '../models/cueStatsTeamLeaderboardResponse';
import type { cueStatsUsageResponse } from '../models/cueStatsUsageResponse';
import type { cueStatsUsageVolumeResponse } from '../models/cueStatsUsageVolumeResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CueStatsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Cue impact and usage recap
   * @returns cueStatsUsageResponse Cue stats retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCueStatsUsage(): CancelablePromise<cueStatsUsageResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/cue/stats/usage',
      errors: {
        500: `Failed to retrieve Cue stats from the upstream source`,
      },
    });
  }

  /**
   * Get Cue credit audit log
   * @returns cueStatsCreditAuditLogResponse Cue stats retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCueStatsCreditAuditLog(): CancelablePromise<cueStatsCreditAuditLogResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/cue/stats/creditAuditLog',
      errors: {
        500: `Failed to retrieve Cue stats from the upstream source`,
      },
    });
  }

  /**
   * Get Cue team leaderboard
   * @returns cueStatsTeamLeaderboardResponse Cue stats retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCueStatsTeamLeaderboard(): CancelablePromise<cueStatsTeamLeaderboardResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/cue/stats/teamLeaderboard',
      errors: {
        500: `Failed to retrieve Cue stats from the upstream source`,
      },
    });
  }

  /**
   * Get Cue return on investment by month
   * @returns cueStatsRoiResponse Cue stats retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCueStatsRoi(): CancelablePromise<cueStatsRoiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/cue/stats/roi',
      errors: {
        500: `Failed to retrieve Cue stats from the upstream source`,
      },
    });
  }

  /**
   * Get the most common Cue actions and estimated time saved
   * @returns cueStatsCommonActionsResponse Cue stats retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCueStatsCommonActions(): CancelablePromise<cueStatsCommonActionsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/cue/stats/commonActions',
      errors: {
        500: `Failed to retrieve Cue stats from the upstream source`,
      },
    });
  }

  /**
   * Get Cue usage and volume by month
   * @returns cueStatsUsageVolumeResponse Cue stats retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCueStatsUsageVolume(): CancelablePromise<cueStatsUsageVolumeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/cue/stats/usageVolume',
      errors: {
        500: `Failed to retrieve Cue stats from the upstream source`,
      },
    });
  }

  /**
   * Get the Cue account-owner contact info (temporary static map)
   * @returns cueStatsContactSalesResponse Cue stats retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCueStatsContactSales(): CancelablePromise<cueStatsContactSalesResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/cue/stats/contactSales',
      errors: {
        500: `Failed to retrieve Cue stats from the upstream source`,
      },
    });
  }

}
